module.exports = __webpack_public_path__ + "img/59_15.3a32f791.png";